module.exports = __webpack_public_path__ + "static/x86-oversea.3e6cac18.png";